import { useState, useEffect, useRef } from 'react';
import { getConfiguracoes, salvarConfiguracoes, uploadLogo, uploadBanner } from '../../services/api';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function AdminConfiguracoes() {
  const [config, setConfig] = useState({
    nome_lanchonete: '', slogan: '', whatsapp: '',
    cor_primaria: '#e63030', cor_secundaria: '#ff6b00',
    taxa_entrega: '3.00', tempo_entrega_min: '30',
    tempo_entrega_max: '50', pedido_minimo: '0',
    aberto: '1', mensagem_fechado: ''
  });
  const [logoUrl, setLogoUrl] = useState(null);
  const [bannerUrl, setBannerUrl] = useState(null);
  const [loadingLogo, setLoadingLogo] = useState(false);
  const [loadingBanner, setLoadingBanner] = useState(false);
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState('');
  const logoRef = useRef();
  const bannerRef = useRef();

  const showToast = (msg) => { setToast(msg); setTimeout(() => setToast(''), 3000); };

  useEffect(() => {
    getConfiguracoes().then(r => {
      setConfig(p => ({ ...p, ...r.data }));
      if (r.data.logo_url) setLogoUrl(r.data.logo_url);
      if (r.data.banner_url) setBannerUrl(r.data.banner_url);
    }).catch(() => {});
  }, []);

  const handleLogo = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    setLoadingLogo(true);
    const fd = new FormData(); fd.append('logo', file);
    try { const r = await uploadLogo(fd); setLogoUrl(r.data.url); showToast('✅ Logo atualizada!'); }
    catch { showToast('❌ Erro ao enviar logo'); }
    finally { setLoadingLogo(false); }
  };

  const handleBanner = async (e) => {
    const file = e.target.files[0]; if (!file) return;
    setLoadingBanner(true);
    const fd = new FormData(); fd.append('banner', file);
    try { const r = await uploadBanner(fd); setBannerUrl(r.data.url); showToast('✅ Banner atualizado!'); }
    catch { showToast('❌ Erro ao enviar banner'); }
    finally { setLoadingBanner(false); }
  };

  const salvar = async () => {
    setLoading(true);
    try { await salvarConfiguracoes(config); showToast('✅ Configurações salvas!'); }
    catch { showToast('❌ Erro ao salvar'); }
    finally { setLoading(false); }
  };

  const Field = ({ label, field, type = 'text', placeholder }) => (
    <div className="input-group">
      <label className="input-label">{label}</label>
      <input className="input-field" type={type} placeholder={placeholder}
        value={config[field] || ''} onChange={e => setConfig(p => ({ ...p, [field]: e.target.value }))} />
    </div>
  );

  return (
    <div style={{ padding: 16 }}>
      {toast && <div style={{ position: 'fixed', top: 60, left: '50%', transform: 'translateX(-50%)', background: 'linear-gradient(90deg,var(--red),var(--orange))', color: '#fff', padding: '10px 20px', borderRadius: 20, fontSize: 13, fontWeight: 700, zIndex: 999 }}>{toast}</div>}

      <h2>🎨 Configurações Visuais</h2>

      {/* LOGO */}
      <div className="card">
        <h3 style={{ marginBottom: 14 }}>🖼️ Logo</h3>
        <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ width: 90, height: 90, borderRadius: 12, background: 'var(--bg4)', border: '2px dashed var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', flexShrink: 0, fontSize: 36 }}>
            {logoUrl ? <img src={`${API_URL}${logoUrl}`} alt="Logo" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : '🍔'}
          </div>
          <div>
            <p style={{ fontSize: 12, color: 'var(--text2)', marginBottom: 8 }}>JPG, PNG ou WebP • Máx 2MB<br />Recomendado: 300×300px</p>
            <input ref={logoRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleLogo} />
            <button className="btn-secondary" style={{ width: 'auto', padding: '8px 16px', fontSize: 12 }}
              onClick={() => logoRef.current.click()} disabled={loadingLogo}>
              {loadingLogo ? '⏳ Enviando...' : '📁 Escolher'}
            </button>
          </div>
        </div>
      </div>

      {/* BANNER */}
      <div className="card">
        <h3 style={{ marginBottom: 12 }}>🖼️ Banner Principal</h3>
        <div style={{ width: '100%', height: 110, borderRadius: 8, background: 'var(--bg4)', border: '2px dashed var(--border)', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden', marginBottom: 10, fontSize: 13, color: 'var(--text3)' }}>
          {bannerUrl ? <img src={`${API_URL}${bannerUrl}`} alt="Banner" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : 'Nenhum banner'}
        </div>
        <input ref={bannerRef} type="file" accept="image/*" style={{ display: 'none' }} onChange={handleBanner} />
        <button className="btn-secondary" style={{ width: 'auto', padding: '8px 16px', fontSize: 12 }}
          onClick={() => bannerRef.current.click()} disabled={loadingBanner}>
          {loadingBanner ? '⏳ Enviando...' : '📁 Escolher banner'}
        </button>
      </div>

      {/* CORES */}
      <div className="card">
        <h3 style={{ marginBottom: 14 }}>🎨 Cores do Tema</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          {[['Cor Primária', 'cor_primaria'], ['Cor Secundária', 'cor_secundaria']].map(([label, field]) => (
            <div key={field}>
              <label className="input-label">{label}</label>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <input type="color" value={config[field] || '#e63030'}
                  onChange={e => setConfig(p => ({ ...p, [field]: e.target.value }))}
                  style={{ width: 44, height: 40, borderRadius: 8, border: '1px solid var(--border)', background: 'none', cursor: 'pointer', padding: 2 }} />
                <input className="input-field" value={config[field] || ''} style={{ flex: 1, fontFamily: 'monospace', fontSize: 13 }}
                  onChange={e => setConfig(p => ({ ...p, [field]: e.target.value }))} />
              </div>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 12, padding: 10, background: 'var(--bg4)', borderRadius: 8 }}>
          <div style={{ fontSize: 11, color: 'var(--text2)', marginBottom: 6 }}>Preview:</div>
          <button style={{ background: `linear-gradient(90deg,${config.cor_primaria},${config.cor_secundaria})`, border: 'none', color: '#fff', padding: '8px 18px', borderRadius: 8, fontWeight: 700, cursor: 'pointer', fontSize: 13 }}>Adicionar ao carrinho 🛒</button>
        </div>
      </div>

      {/* INFO */}
      <div className="card">
        <h3 style={{ marginBottom: 14 }}>📋 Informações</h3>
        <Field label="Nome da Lanchonete" field="nome_lanchonete" placeholder="Lanches do Parque" />
        <Field label="Slogan" field="slogan" placeholder="Os melhores lanches!" />
        <Field label="WhatsApp (só números)" field="whatsapp" placeholder="11999999999" />
      </div>

      {/* ENTREGA */}
      <div className="card">
        <h3 style={{ marginBottom: 14 }}>🛵 Entrega</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10 }}>
          <Field label="Taxa (R$)" field="taxa_entrega" placeholder="3.00" />
          <Field label="Pedido mínimo (R$)" field="pedido_minimo" placeholder="0" />
          <Field label="Tempo mín. (min)" field="tempo_entrega_min" placeholder="30" />
          <Field label="Tempo máx. (min)" field="tempo_entrega_max" placeholder="50" />
        </div>
      </div>

      {/* STATUS */}
      <div className="card">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <div>
            <div style={{ fontWeight: 700 }}>Loja aberta</div>
            <div style={{ fontSize: 12, color: config.aberto === '1' ? '#2ea82e' : 'var(--red)' }}>{config.aberto === '1' ? '🟢 Aceitando pedidos' : '🔴 Fechada'}</div>
          </div>
          <label style={{ position: 'relative', width: 52, height: 28, cursor: 'pointer' }}>
            <input type="checkbox" checked={config.aberto === '1'} onChange={e => setConfig(p => ({ ...p, aberto: e.target.checked ? '1' : '0' }))} style={{ opacity: 0, width: 0, height: 0 }} />
            <span style={{ position: 'absolute', inset: 0, background: config.aberto === '1' ? 'var(--orange)' : 'var(--bg4)', border: `1px solid ${config.aberto === '1' ? 'var(--orange)' : 'var(--border)'}`, borderRadius: 14, transition: '.2s' }}>
              <span style={{ position: 'absolute', width: 22, height: 22, background: '#fff', borderRadius: '50%', top: 2, left: config.aberto === '1' ? 26 : 2, transition: '.2s' }} />
            </span>
          </label>
        </div>
        <Field label="Mensagem quando fechado" field="mensagem_fechado" placeholder="Estamos fechados. Volte em breve!" />
      </div>

      <button className="btn-primary" onClick={salvar} disabled={loading}>
        {loading ? '⏳ Salvando...' : '💾 Salvar todas as configurações'}
      </button>
    </div>
  );
}
